// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useMemo, useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { sortBy } from 'lodash';
import Button from '../../../components/Button';
import LoadingIcon from '../../../components/LoadingIcon';
import SearchBar from '../../../components/SearchBar';
import moment from 'moment';
import TitleIcon from '../../../assets/images/button-active.svg';
import IconDrop from '../../../assets/images/icon-drop.svg';
import Pagination from '../../../components/Pagination';
import RefreshIcon from '../../../assets/images/refresh-arrow.svg';

const S = {
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
  `,
  Container: styled.div`
    padding: 20px 80px;
    text-align: center;
  `,
  CheckRecordWapper: styled.div`
    background: #FFFFFF;
    border-radius: 11px;
    margin-top: 11px;
    position: fixed;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    top: 10%;
    left: 50%;
    transform: translate(-51%,0%);
    width: 45rem;
  `,
  CheckRecordCard: styled.div<{ visible: boolean }>`
    max-height: ${(props) => props.visible ? '20vw' : '0px'};
    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow:hidden;
  `,
  CloseBar: styled.div`
    background: #EF8200;
    border-radius: 11px 11px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  CloseIconContainer: styled.div`
    padding: 0px 17px 4px;
    cursor: pointer;
  `,
  CloseIcon: styled.div`
    display: inline-block;
    width: 14px;
    height: 2px;
    background: #FFF;
    line-height: 0;
    font-size: 0;
    vertical-align: middle;
    transform: rotate(45deg);
    &::after {
      content: "/";
      display: block;
      width: 14px;
      height: 2px;
      background: #FFF;
      transform: rotate(-90deg);
    }
  `,
  CheckRecordTitle: styled.p`
    color: #353535;
    font-size: 18px;
    margin-bottom: 15px;
  `,
  SubmitAction: styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;
  `,
  SubmitButton: styled(Button)`
    background: #EF8200;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 7px;
    padding: 4px 27px;
  `,
  ErrorText: styled.p`
    color: #ff4e4e;
  `,
  Content: styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  `,
  AttendTitleIcon: styled.img.attrs({ src: TitleIcon })`
    width: 20px;
    height: 20px;
  `,
  AttendTitle: styled.p`
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  AttendRecordContainer: styled.div`
    display: grid;
    grid-template-columns: 1.5fr repeat(2, 1fr);
    max-height: 47vh;
    overflow: scroll;

    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-button {
      background: transparent;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #E6E6E6;
      border: 1px solid #E6E6E6;
    }
    &::-webkit-scrollbar-track {
      box-shadow: transparent;
    }
  `,
  AttendItemContainer: styled.div`
    display: grid;
    grid-column: 1/ -1;
    grid-template-columns: 1.5fr repeat(2, 1fr);
  `,
  RecordTitle: styled.p<{ isEmail?: boolean }>`
    font-size: 14px;
    ${props => props.isEmail ? 'text-align: left;': ''}
    font-weight: 700;
    position: relative;
    cursor: pointer;
    border-bottom: 1px solid #666666;
    &:hover {
      background-color: #eeeeee;
    }
  `,
  RecordItem: styled.p<{ isEmail?: boolean }>`
    font-size: 14px;
    ${props => props.isEmail ? `
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
    ` : ''}
  `,
  NoDataText: styled.p`
    font-size: 16px;
    grid-column: 1/ -1;
    margin-top: 1rem;
  `,
  LoadingContainer: styled.div`
    display: flex;
    margin-top: auto;
    place-content: center;
  `,
  SortIcon: styled.img.attrs({ src: IconDrop, alt: 'icon-drop' }) <{ isAscending?: boolean }>`
    position: absolute;
    top: 50%;
    margin-left: 5px;
    transition: transform .5s;
    transform: translateY(-50%) rotate(${props => props.isAscending ? 0 : 180}deg);
  `,
  AttendSearch: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
  `,
  Pagination: styled(Pagination)`
    margin-top: 3%;
    justify-content: center;
  `,
  ReloadAction: styled.div`
  `,
  ReloadIcon: styled.img.attrs({ src: RefreshIcon})`
    border: 1px solid #666666;
    border-radius: 4px;
    padding: 4px 0.5rem;
    width: 2.5rem;
    height: 25px;
    cursor: pointer;
    &:hover {
      background-color: #eeeeee;
    }
  `
}

export interface memberData {
  email: string;
  checkOutTime: Date;
  checkInTime: Date;
}

interface Props {
  data: memberData[]
  closeShowCheckRecord: () => void;
  refresh: () => void;
  loading: boolean;
  error: string;
}

const CheckInRecord = (props: Props) => {
  const data = props.data;
  const closeShowCheckRecord = props.closeShowCheckRecord;
  const loading = props.loading;
  const error = props.error;
  const refresh = props.refresh;
  const [sortKey, setSortKey] = useState('');
  const [isSearch, setIsSearch] = useState(false);
  const [isAscending, setIsAscending] = useState(false);
  const [displayList, setDisplayList] = useState(props.data);

  const currentTableData = useMemo(() => {
    return displayList;
  }, [sortKey, isAscending, isSearch, loading]);

  const handleSort = (type: string) => {
    console.log(type);
    data.sort((a: any, b: any) => {
      if (!isAscending) {
        [a, b] = [b, a];
      }
      if (type === 'email') {
        return a.email.localeCompare(b.email);
      } else if (type === 'checkInTime' || type === 'checkOutTime') {
        if (!a[type] && !b[type]) {
          return -1;
        }
        if (!a[type]) {
          return isAscending ? 1 : -1;
        }
        if (!b[type]) {
          return isAscending ? -1 : 1;
        }
        return new Date(b[type]).getTime() - new Date(a[type]).getTime();
      }
    })
    console.log(data);
    setSortKey(type);
    if (type === sortKey) {
      setIsAscending(!isAscending);
    } else {
      setIsAscending(true);
    }
  }

  const handleSearch = (value: string) => {
    const searchList = data.filter((item: any) => {
      return item.email.includes(value);
    })
    setDisplayList(searchList);
    setIsSearch(!isSearch);
  }

  useEffect(() => {
    setDisplayList(data);
  }, [data])

  return (
    <S.PopMask>
      <S.CheckRecordWapper>
        <S.CloseBar>
          <S.CloseIconContainer onClick={() => { closeShowCheckRecord() }}><S.CloseIcon/></S.CloseIconContainer>
        </S.CloseBar>
        <S.Container>
          { loading ? (
            <S.LoadingContainer>
              <LoadingIcon size={10} />
            </S.LoadingContainer>
          ) : error ? (
            <S.ErrorText>
              {error}
            </S.ErrorText>
          ) : (
            <>
              <S.AttendTitle><S.AttendTitleIcon/>Member Check in/out status</S.AttendTitle>
              <S.AttendSearch>
                <SearchBar handleSearch={handleSearch} searchType="Email"/>
                <S.ReloadAction>
                  <S.ReloadIcon onClick={refresh}/>
                </S.ReloadAction>
              </S.AttendSearch>
              <S.AttendRecordContainer>
                <S.RecordTitle isEmail onClick={() => { handleSort('email') }}>Email{ sortKey === 'email' && <S.SortIcon isAscending={isAscending} /> }</S.RecordTitle>
                <S.RecordTitle onClick={() => { handleSort('checkInTime') }}>Check In{ sortKey === 'checkInTime' && <S.SortIcon isAscending={isAscending} /> }</S.RecordTitle>
                <S.RecordTitle onClick={() => { handleSort('checkOutTime') }}>Check Out{ sortKey === 'checkOutTime' && <S.SortIcon isAscending={isAscending} /> }</S.RecordTitle>
                { currentTableData.map((item: memberData) => {
                  return (
                    <S.AttendItemContainer key={item.email}>
                      <S.RecordItem isEmail>{item.email}</S.RecordItem>
                      <S.RecordItem>{item.checkInTime ? moment(item.checkInTime).format('YYYY/MM/DD HH:mm:ss') : '--'}</S.RecordItem>
                      <S.RecordItem>{item.checkOutTime ? moment(item.checkOutTime).format('YYYY/MM/DD HH:mm:ss') : '--'}</S.RecordItem>
                    </S.AttendItemContainer>
                  )
                }) }
                { data.length === 0 ? <S.NoDataText>No Data</S.NoDataText> : null }
              </S.AttendRecordContainer>
            </>
          )}
          <S.SubmitAction>
            <S.SubmitButton onClick={() => { closeShowCheckRecord() }}>
              <FormattedMessage id="D034" />
            </S.SubmitButton>
          </S.SubmitAction>
        </S.Container>
      </S.CheckRecordWapper>
    </S.PopMask>
  )
}

export { CheckInRecord as default };
